module.exports = __webpack_public_path__ + "img/38_20.75f4056c.png";